import { appConfig } from "../InitData";
import { getConfiguration } from "./utils";

function isScriptInGDPRCategory(scriptUrl, gdprCategory) {
    const configuration = getConfiguration();

    try {
        const GDPR_scriptCategories = configuration?.gdprscc;
        return GDPR_scriptCategories?.[scriptUrl]?.[0]?.includes(gdprCategory);
    }catch(err) {
        console.log(err);
        return false;
    }
   
}

export function isScriptGDPRCompliant(scriptUrl){
    let isCompliant = true;

    try {
        
       
        /*GDPR_scriptCategories = {'https://widgets.sir.sportradar.com/64787c234dd7f5dde9b82ca6ac6db92d/widgetloader':['prf,mkt,sts']}
        appConfig['COOKIE_CONSENT'] = {'preferences':false,'statistics':false,'marketing':false}*/
     
        if(appConfig?.COOKIE_CONSENT){
            const preferencesRejected = appConfig?.COOKIE_CONSENT['preferences'] == false;
            const statisticsRejected = appConfig?.COOKIE_CONSENT['statistics'] == false;
            const marketingRejected =  appConfig?.COOKIE_CONSENT['marketing'] == false;
            let isPreferencesCompliant = true;
            let isStatisticsCompliant = true;
            let isMarketingCompliant = true;
    
            if(preferencesRejected){
                isPreferencesCompliant =  !(isScriptInGDPRCategory(scriptUrl,'all') || isScriptInGDPRCategory(scriptUrl,'prf'));
            }
            if(statisticsRejected){
                isStatisticsCompliant =  !(isScriptInGDPRCategory(scriptUrl,'all') || isScriptInGDPRCategory(scriptUrl,'sts'));
            }
            if(marketingRejected){
                isMarketingCompliant =  !(isScriptInGDPRCategory(scriptUrl,'all') || isScriptInGDPRCategory(scriptUrl,'mkt'));
            }

            isCompliant = isPreferencesCompliant && isStatisticsCompliant && isMarketingCompliant;
        }
    }catch(err) {
        console.log(err);
    }
    
    return isCompliant;
}